module.exports = __webpack_public_path__ + "static/media/dashboard.ea1cd194.svg";